/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementListProjectFieldsResponse {
    getFixupPrototypeFunction() { return JiraServiceManagementListProjectFieldsResponse.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementListProjectFieldsResponse>): JiraServiceManagementListProjectFieldsResponse {
        let obj = Object.assign(new JiraServiceManagementListProjectFieldsResponse(), model);
        JiraServiceManagementListProjectFieldsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementListProjectFieldsResponse>): JiraServiceManagementListProjectFieldsResponse {
        if (!model) return null;
        return JiraServiceManagementListProjectFieldsResponse.newInstance(<JiraServiceManagementListProjectFieldsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementListProjectFieldsResponse) {
        if (!obj) return;

        models.JiraServiceManagementListProjectFieldsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementListProjectFieldsResponse): boolean {
        Object.setPrototypeOf(obj, JiraServiceManagementListProjectFieldsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.fields) {
            for (let val of this.fields) {
                models.JiraServiceManagementProjectFields.fixupPrototype(val);
            }
        }
    }

    fields: Array<models.JiraServiceManagementProjectFields>;

}
